export const appStoreUrl = "https://apps.apple.com/app/id6807502894";
